import { createAction } from '@reduxjs/toolkit';

/**
 * Broadcast action that tenant-scoped slices listen to via `extraReducers` to
 * clear their state during org hand-off. Add a listener to any slice whose
 * contents belong to a single tenant.
 */
export const tenantScopeReset = createAction('tenantScope/reset');
